const userServices = angular.module('userServices', []);

userServices.service('userService', function (
    $http,
    $rootScope,
    $window,
    _,
    $q,
    $state,
    config,
    eventService,
    toasterService
) {
    let name = null;
    let initialized = false;
    let authorized = false;
    let rights = [];
    let id;

    let backEnv;

    function update() {
        return $http.get(config.api + 'whoami').then(function (response) {
            backEnv = response.data.env;
            name = response.data.name;
            id = response.data.id;
            rights = response.data.rights && response.data.rights.length > 0 ? response.data.rights : [];
            let oldAuthValue = authorized;
            authorized = rights.length !== 0;
            if (oldAuthValue !== authorized) {
                if (authorized) {
                    eventService.trigger('userservice:authorized');
                } else {
                    eventService.trigger('userservice:unauthorized');
                }
            }
            eventService.trigger('update-rights');
            initialized = true;
        });
    }


    function isAuthorized() {
        return authorized;
    }

    function login(user) {
        return update().then(function () {
            return _login(user);
        });
    }

    function _login(user) {
        return $http({
            method: 'POST',
            url: config.api + 'login',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: 'username=' + encodeURIComponent(user.username) + '&password=' + encodeURIComponent(user.password),
        }).then(function onSuccess(data) {
            if (data.status === 200) {
                update().then(function () {
                    if (hasRight('ACCESS_DASHBOARD')) {
                        $state.go('dashboard');
                    } else {
                        $state.go('frontpage');
                    }
                });
            } else if (data.status === 403 || data.status === 404 || data.status === 401) {
                toasterService.error('toaster.login-failed-title', 'toaster.login-failed');
            }
            return data;
        });
    }

    const logout = async () => {
        $window.location.href = backEnv.logoutUri;
        await $http.post(config.api + 'logout', {});
        update().then(() => {
            eventService.trigger('userservice:unauthorized');
        });
    };

    /*
    * Checker functions for different user rights
    *
    * For different projects new functions can be added
    * example:
     function hasUserRole() {
       return hasRight('USER_ROLE');
     }
    */

    /*
     * TAB ACCESS RIGHTS
     */

    function hasAccessDash1() {
        return hasRight('ACCESS_DASHBOARD');
    }

    function hasAccessDash2() {
        return hasRight('ACCESS_DASHBOARD2');
    }

    function hasAccessFleet() {
        return hasRight('ACCESS_FLEET');
    }

    function hasAccessUsers() {
        return hasRight('ACCESS_USERS');
    }

    function hasAccessPackages() {
        return hasRight('ACCESS_PACKAGES');
    }

    function hasAccessPIS() {
        return hasRight('ACCESS_PIS');
    }

    function hasAccessCarView() {
      return hasRight('ACCESS_CAR_VIEW');
    }

    function hasAccessConditionMonitor() {
      return hasRight('ACCESS_CONDITION_MONITOR');
    }

    function hasRMMView() {
        return hasRight('VIEW_RMM') && __env.operator !== 'bakerloo';
    }

    function hasAccessAnalysis() {
        return hasRight('ACCESS_ANALYSIS');
    }

    function hasAccessAlarms() {
        return hasRight('ACCESS_ALARMS');
    }

    function hasAccessOTOOL() {
        return hasRight('ACCESS_OTOOL');
    }

    function hasAccessPSA() {
        return hasRight('PSA_USER');
    }

    function hasAccessTrackCondition() {
        return hasRight('ACCESS_TRACK_CONDITION');
    }

    function hasAccessUpdateConfigurations() {
        return hasRight('UPDATE_CONFIGURATIONS');
    }

    function hasAccessAssetCondition() {
        return hasRight('ASSET_STATUS_LIST');
    }

    /*
     * GRIDLET RIGHTS
     */

    function hasAlarmsRead() {
        return hasRight('READ_ALARMS_GRIDLET');
    }

    function hasNotificationRead() {
        return hasRight('READ_NOTIFICATION_GRIDLET');
    }

    function hasSystemStatusRead() {
        return hasRight('READ_SYSTEMSTATUS_GRIDLET');
    }

    function hasActiveEventRead() {
        return hasRight('READ_ACTIVE_EVENT_GRIDLET');
    }

    function hasEventHistoryRead() {
        return hasRight('READ_EVENT_HISTORY_GRIDLET');
    }

    function hasAuditEventsRead() {
      return hasRight('READ_AUDIT_EVENTS_GRIDLET');
    }

    function hasQRFleetInfoRead() {
        return hasRight('READ_QR_FLEET_INFO_GRIDLET');
    }

    function hasTrainSoftwareStatusRead() {
      return hasRight('READ_TRAIN_SOFTWARE_STATUS_GRIDLET');
    }

    function hasFleetInfoRead() {
        return hasRight('READ_FLEET_INFO_GRIDLET');
    }

    function hasFleetStatusRead() {
        return hasRight('READ_FLEET_STATUS_GRIDLET');
    }

    function hasFleetHealthRead() {
        return hasRight('READ_FLEET_HEALTH_GRIDLET');
    }

    function hasTrainHealthRead() {
        return hasRight('READ_TRAIN_HEALTH_GRIDLET');
    }

    function hasConditionAlertRead() {
        return hasRight('READ_CONDITION_ALERT_GRIDLET');
    }

    function hasConditionEventRead() {
        return hasRight('READ_CONDITION_EVENT_GRIDLET');
    }

    function hasCarListRead() {
        return hasRight('READ_CAR_LIST_GRIDLET')
    }

    function hasCarViewRead() {
      return hasRight('READ_CAR_VIEW_GRIDLET');
    }

    function hasDashOneEditRight() {
        return hasRight('EDIT_DASH1');
    }

    function hasDashTwoEditRight() {
        return hasRight('EDIT_DASH2');
    }

    /*
     * PIS TOOL RIGHTS
     */

    const hasCommitPIS = () => hasRight('COMMIT_PIS');
    const hasEditPIS = () => hasRight('EDIT_PIS');
    const hasPISDeploy = () => hasRight('DEPLOY_PIS');
    const hasPISApprove = () => hasRight('APPROVE_PIS');

    /*
     * KEY MANAGER RIGHTS
     */
    const hasViewKeyManager = () => hasRight('VIEW_KEY_MANAGER');
    const hasCreateKey = () => hasRight('CREATE_KEY_KEY_MANAGER');
    const hasDeleteKey = () => hasRight('DELETE_KEY_KEY_MANAGER');

    /*
     * MISC RIGHTS
     */
    function hasDeleteEvents() {
        return hasRight('DELETE_EVENTS');
    }

    function hasAccessDriversView() {
        return hasRight('ACCESS_DRIVERS_VIEW');
    }

    function hasModifyUsers() {
        return hasRight('MODIFY_USERS');
    }

    function hasModifyEkeAdmin() {
        return hasRight('MODIFY_EKE_ADMIN');
    }

    function hasPurgeLogs() {
        return hasRight('PURGE_LOGS');
    }

    function hasModifyTrainParameter() {
        return hasRight('MODIFY_TRAIN_PARAMETER');
    }

    function hasReadTrainParameter() {
        return hasRight('READ_TRAIN_PARAMETER');
    }

    function hasEditDescriptors() {
        return hasRight('EDIT_DESCRIPTORS');
    }

    function hasFileUpload() {
        return hasRight('CAN_UPLOAD_FILES');
    }

    function hasFileUploadToTrain() {
        return hasRight('CAN_UPLOAD_FILES_TO_TRAIN');
    }

    function hasActivatePackage() {
        return hasRight('CAN_ACTIVATE_PACKAGE');
    }

    function hasLoginMT() {
        return hasRight('LOGIN_MT');
    }

    function hasEditCI() {
        return hasRight('EDIT_CI');
    }

    const hasTrainManagement = () => hasRight('ACCESS_TRAIN_MANAGEMENT');

    const hasTrainNetwork = () => hasRight('ACCESS_TRAIN_NETWORK');

    const hasACCAT = () => hasRight('ACCAT');

    const hasWGMFailureReports = () => hasRight('WGM_FAILURE_REPORTS');

    function hasRight(right) {
        return rights.includes(right);
    }

    function hasRights(requiredRights) {
        for (let i = 0; i < requiredRights.length; i++) {
            if (!hasRight(requiredRights[i])) return false;
        }

        return true;
    }

    function getName() {
        return name;
    }

    function isCurrentUser(userId) {
        return userId === id;
    }

    function getCurrentUserId() {
        return id;
    }

    function resolve(requiredRights) {
        requiredRights = requiredRights || [];
        let deferred = $q.defer();

        let unwatch = $rootScope.$watch(
            function () {
                return initialized;
            },
            function (newVal) {
                if (newVal) {
                    if (hasRights(requiredRights)) {
                        deferred.resolve();
                    } else {
                        deferred.reject();
                    }

                    unwatch();
                }
            }
        );

        return deferred.promise;
    }

    function forgotPassword(email) {
        return $http
            .put(config.api + 'password-reset-request', {
                email: email,
            })
            .then(function () {
            });
    }

    function resetPassword(password, token) {
        return $http
            .put(config.api + 'password-reset', {
                password: password,
                passwordResetToken: token,
            })
            .then(function (data) {
                if (data.status === 200) {
                    $state.go('frontpage');
                } else if (data.status === 400) {
                    toasterService.error('toaster.common-error-title', 'error-type.' + data.data.errorType);
                }
            });
    }

    function changePin(pin) {
        return $http
            .post(config.api + 'pin', {
                pin: pin,
            })
            .then(function (data) {
                if (data.status === 200) {
                    $state.go('frontpage');
                } else if (data.status >= 400) {
                    toasterService.error(
                        'toaster.common-error-title',
                        'error-type.' + data.data.errorType
                    );
                }
            });
    }

    function changeReportSettings(settings) {
        return $http
          .post(config.api + 'report',
              settings
          )
          .then(function (data) {
              if (data.status === 200) {
                  $state.go('users');
              } else if (data.status >= 400) {
                  toasterService.error(
                    'toaster.common-error-title',
                    'error-type.' + data.data.errorType
                  );
              }
          });
    }

    function hasReadReportSetting() {
        return hasRight('READ_REPORT_SETTING');
    }
    function hasCreateReportSetting() {
        return hasRight('CREATE_REPORT_SETTING');
    }

    function hasServiceVersions() {
        return hasRight('READ_SERVICE_VERSIONS');
    }

    function setUserDisabled(id, disabled) {
        return $http.put(config.api + 'user/disabled', null, {
            params: { id: id, disabled: disabled }
        });
    }

    return {
        update: update,
        isAuthorized: isAuthorized,
        login: login,
        logout: logout,
        hasAccessDash1: hasAccessDash1,
        hasAccessDash2: hasAccessDash2,
        hasAccessFleet: hasAccessFleet,
        hasAccessCarView: hasAccessCarView,
        hasAccessConditionMonitor: hasAccessConditionMonitor,
        hasAccessAssetCondition: hasAccessAssetCondition,
        hasDashOneEditRight: hasDashOneEditRight,
        hasDashTwoEditRight: hasDashTwoEditRight,
        hasRight: hasRight,
        hasRights: hasRights,
        hasAccessPSA: hasAccessPSA,
        hasAlarmsRead: hasAlarmsRead,
        hasNotificationRead: hasNotificationRead,
        hasSystemStatusRead: hasSystemStatusRead,
        hasActiveEventRead: hasActiveEventRead,
        hasEventHistoryRead: hasEventHistoryRead,
        hasAuditEventsRead: hasAuditEventsRead,
        hasQRFleetInfoRead: hasQRFleetInfoRead,
        hasCarListRead: hasCarListRead,
        hasCarViewRead: hasCarViewRead,
        hasTrainSoftwareStatusRead: hasTrainSoftwareStatusRead,
        hasFleetInfoRead: hasFleetInfoRead,
        hasFleetStatusRead: hasFleetStatusRead,
        hasFleetHealthRead: hasFleetHealthRead,
        hasTrainHealthRead: hasTrainHealthRead,
        hasConditionAlertRead: hasConditionAlertRead,
        hasConditionEventRead: hasConditionEventRead,
        hasModifyUsers: hasModifyUsers,
        hasModifyEkeAdmin: hasModifyEkeAdmin,
        hasPurgeLogs: hasPurgeLogs,
        hasModifyTrainParameter: hasModifyTrainParameter,
        hasReadTrainParameter: hasReadTrainParameter,
        hasEditDescriptors: hasEditDescriptors,
        hasAccessPackages: hasAccessPackages,
        hasFileUpload: hasFileUpload,
        hasFileUploadToTrain: hasFileUploadToTrain,
        hasActivatePackage: hasActivatePackage,
        hasLoginMT: hasLoginMT,
        hasAccessPIS: hasAccessPIS,
        hasRMMView: hasRMMView,
        hasAccessAnalysis: hasAccessAnalysis,
        hasAccessAlarms: hasAccessAlarms,
        hasAccessUsers: hasAccessUsers,
        hasEditPIS: hasEditPIS,
        hasCommitPIS: hasCommitPIS,
        hasPISDeploy: hasPISDeploy,
        hasPISApprove: hasPISApprove,
        hasAccessOTOOL: hasAccessOTOOL,
        hasAccessDriversView: hasAccessDriversView,
        hasAccessTrackCondition: hasAccessTrackCondition,
        hasAccessUpdateConfigurations: hasAccessUpdateConfigurations,
        hasACCAT: hasACCAT,
        hasTrainManagement: hasTrainManagement,
        hasTrainNetwork: hasTrainNetwork,
        hasWGMFailureReports: hasWGMFailureReports,
        hasViewKeyManager: hasViewKeyManager,
        hasCreateKey: hasCreateKey,
        hasDeleteKey: hasDeleteKey,
        getName: getName,
        getCurrentUserId: getCurrentUserId,
        isCurrentUser: isCurrentUser,
        resolve: resolve,
        resetPassword: resetPassword,
        forgotPassword: forgotPassword,
        hasEditCI: hasEditCI,
        changePin: changePin,
        changeReportSettings: changeReportSettings,
        hasReadReportSetting: hasReadReportSetting,
        hasCreateReportSetting: hasCreateReportSetting,
        hasServiceVersions: hasServiceVersions,
        hasDeleteEvents: hasDeleteEvents,
        setUserDisabled: setUserDisabled
    };
});

userServices.service('accountService', function ($resource, config) {
    let rest = $resource(
        config.api + 'user/',
        {},
        {
            update: {
                method: 'PUT',
            },
            create: {
                method: 'POST',
            },
            delete: {
                method: 'DELETE',
                params: {
                    id: '@id',
                  },
                  transformResponse: function (data, headers, statusCode) {
                    return {
                      data: data,
                      headers: headers(),
                      statusCode: statusCode
                    };
                  }
            },
            getAll: {
                method: 'GET',
                url: config.api + 'user/list/',
                isArray: true,
            },
            getUser: {
                method: 'GET',
            },
            getUserName: {
                method: 'GET',
                url: config.api + 'user/name/',
            },
            getCurrentUser: {
                method: 'GET',
                url: config.api + 'user/current-user',
                isArray: false,
            },
            getGroups: {
                method: 'GET',
                url: config.api + 'user/groups/',
                isArray: true,
            },
            getUserReportSetting: {
                url: config.api + 'report/:id',
                method: 'GET',
                isArray: true
            },
            getReportType: {
                url: config.api + 'report/report-type',
                method: 'GET',
                isArray: true
            },
        }
    );

    return {
        getAll: function () {
            return rest.getAll().$promise;
        },
        get: function (object) {
            return rest.query({ id: object.id }).$promise;
        },
        create: function (object) {
            return rest.save(object).$promise;
        },
        delete: function (object) {
            return rest.delete(object).$promise;
        },
        update: function (object) {
            return rest.update(object).$promise;
        },
        getUser: function (userId) {
            return rest.getUser({ id: userId }).$promise;
        },
        getUserName: function (userId) {
            return rest.getUserName({ id: userId }).$promise;
        },
        getCurrentUser: function () {
            return rest.getCurrentUser().$promise;
        },
        getGroups: function () {
            return rest.getGroups().$promise;
        },
        getUserReportSetting: function(userId) {
            return rest.getUserReportSetting({ id: userId }).$promise;
        },
        getReportType: function() {
            return rest.getReportType().$promise;
        }
    };
});
